<template>
  <div>
    <b-card>
      <template #header>
        <span class="pull-left mt-2 mb-2"><strong>Beschikbare transportdagen</strong></span>
        <b-button type="button" class="pull-right" variant="primary" v-b-modal.add-transportation-day v-can="'transportdagen aanpassen'">Transportdag toevoegen</b-button>
        <b-button variant="danger" class="pull-right mr-2" v-b-modal.delete-slots
                  v-can="'transportdagen aanpassen'" :disabled="selectedSlots.length === 0 || isDeleting">
          Verwijderen <b-spinner v-show="isDeleting" small type="grow"/>
        </b-button>

      </template>
      <b-list-group class="table-list-group">
        <b-list-group-item>
          <b-row>
            <b-col cols="12" md="1">
              <b-check-group>
                <b-checkbox v-can="'transportdagen aanpassen'" v-model="hasSelection" :disabled="checkboxMultipleTransportDaysDisabled" :indeterminate="hasPartialSelection" />
              </b-check-group>
            </b-col>
            <b-col cols="12" md="3"><strong>Week</strong></b-col>
            <b-col cols="12" md="3"><strong>Dag</strong></b-col>
            <b-col cols="12" md="5"><strong>Datum</strong></b-col>
          </b-row>
        </b-list-group-item>
        <b-list-group-item v-for="slot in slots" :key="slot.id">
          <b-row>
            <b-col cols="12" md="1">
              <b-checkbox v-can="'transportdagen aanpassen'" v-model="selectedSlots" :value="slot.id" :disabled="isDeleting" />
            </b-col>
            <b-col cols="12" md="3">
              {{formatWeek(slot.date)}}
            </b-col>
            <b-col cols="12" md="3">
              {{formatDay(slot.date)}}
            </b-col>
            <b-col cols="12" md="5">
              {{formatDate(slot.date)}}
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <b-modal id="add-transportation-day" title="Transportdagen toevoegen" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-alert variant="danger" :show="errors !== null">
          <ul class="mt-3">
            <li v-for="error in errors">{{error.toString()}}</li>
          </ul>
        </b-alert>
        <b-row>
          <b-col cols="12" class="custom-inline-datepicker">
            <date-picker name="new_dates" placeholder="Selecteer de transportdagen" v-model="new_dates.date" :config="datepickerOptions" v-can.disable="'transportdagen aanpassen'" />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <hr>
            <b-button type="button" class="ml-0" @click.prevent="hideModal">Annuleren</b-button>
            <b-button type="submit" :disabled="!new_dates.date || new_dates.date.length === 0" variant="primary" class="pull-right">Voeg {{buttonLabel}} toe</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal id="delete-slots" ref="delete-slots" title="Verwijder transportdagen">
      <p class="my-4">
        Weet je zeker dat je deze {{selectedSlots.length}} transportdagen wilt verwijderen?
      </p>
      <template #modal-footer>
        <b-button @click="$bvModal.hide('delete-slots')">Nee</b-button>
        <b-button variant="danger" @click="deleteItems">Ja, verwijder</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import {deleteItem, getData, addData, updateData} from '../../api';
  import moment from 'moment';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import { Dutch } from "flatpickr/dist/l10n/nl.js";
  import router from "@/router";

export default {
  name: 'delivery-slots',
  props: ['locationId'],
  components: { 'DatePicker': flatPickr },
  data() {
    return {
      slots: [],
      fields: [],
      new_dates: {
        date: [],
      },
      selectedSlots: [],
      checkboxMultipleTransportDaysDisabled: false,
      isDeleting: false,
      datepickerOptions: {
        locale: Dutch,
        dateFormat: 'Z',
        mode: 'multiple',
        weekNumbers: true,
        inline: true,
        "disable": [
          (date) => {
            return (date.getDay() === 0) || this.isAlreadySelected(date);
          }
        ],
        minDate: new Date(),
      },
      errors: null,
    }
  },
  methods: {
    async getItems() {
      const slots = await getData('locations/' + this.locationId + '/delivery-slots').then(response => response.data);
      this.slots = slots.data;

      this.$nextTick( () => {
        this.slots.length === 0 ? this.checkboxMultipleTransportDaysDisabled = true : false;
      })
    },
    async deleteItems() {
      this.isDeleting = true;

      this.$refs['delete-slots'].hide();

      await addData(`locations/${this.locationId}/delivery-slots/delete`, {
        items: this.selectedSlots,
      } );

      this.$router.go(0);

      await this.getItems();

      this.selectedSlots = [];
      this.isDeleting = false;
    },
    async addItem() {
      this.errors = null;

      if (!this.new_dates.date || this.new_dates.date.length === 0) return;

      const data = {
        date: this.new_dates.date.split(',').map(item => item.trim()),
        location_id: this.locationId
      };

      const addSlot = await addData(`locations/${data.location_id}/delivery-slots`, data);

      if (addSlot.status === 200) {
        alert('Transportdag(en) toegevoegd!');
        this.new_dates.date = [];
        this.getItems();
        this.$bvModal.hide('add-transportation-day');
      } else if (addSlot.status === 422) {
        this.errors = addSlot.data.errors;
      } else {
        this.new_dates.date = [];
        this.getItems();
        this.$bvModal.hide('add-transportation-day');
      }
    },
    formatWeek(date) {
      const d = moment(date, 'DD-MM-YYYY').week();
      return this.capitalize(`Week ${d}`);
    },
    formatDay(date) {
      const d = moment(date, 'DD-MM-YYYY').format('dddd');
      return this.capitalize(d);
    },
    formatDate(date) {
      const d = moment(date, 'DD-MM-YYYY').format('DD-MM-YYYY');
      return this.capitalize(d);
    },
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    hideModal() {
      this.$bvModal.hide('add-transportation-day');
      this.new_dates.date = [];
    },
    isAlreadySelected(date) {
      const nd = moment(date).toISOString();

      return this.initialDates.indexOf(nd) > -1;
    }
  },
  computed: {
    hasSelection: {
      get: function(){
        return this.selectedSlots.length === this.slots.length;
      },
      set: function(value){
        if(value){
          this.selectedSlots = this.slots.map(s => s.id);
        } else {
          this.selectedSlots = [];
        }
      }
    },
    hasPartialSelection() {
      return this.selectedSlots.length > 0 && this.selectedSlots.length !== this.slots.length;
    },
    buttonLabel() {
      //  24 is thee length a normal ISO datestring
      return this.new_dates.date.length <= 24 ? 'transportdag' : 'transportdagen';
    },
    initialDates() {
      if (!this.slots) return [];
      const dates = this.slots;
      let n = 0;
      let len = dates.length;
      let collection = [];

      for (n; n < len; n++) {
        const d = dates[n].date;
        const nd = moment(d, 'DD-MM-YYYY').toISOString();
        collection.push(nd);
      }

      return collection;
    }
  },
  beforeMount() {
    this.getItems();
  }
}

</script>
<style>
.selected-date {
  min-width: 100% !important;
  margin-bottom: 20px;
}

</style>
